import { useState } from "react";
import axios from "axios";
import { DialogLayout } from "@/subframe/layouts/DialogLayout";
import { IconWithBackground } from "@/subframe/components/IconWithBackground";
import { TextField } from "@/subframe/components/TextField";
import { Button } from "@/subframe/components/Button";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { addLabel } from "../../redux/reducers/authSlice";
import { addEsChatToConfig } from "../../Utils/apiUtils";

interface LabelCreationProps {
  open: boolean;
  setIsLabelCreationOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function LabelCreation({ open, setIsLabelCreationOpen }: LabelCreationProps) {
  const dispatch = useDispatch<AppDispatch>();
  const [label, setLabel] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSave = async () => {
    if (!label.trim()) {
      setError("Label name cannot be empty.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const config = addEsChatToConfig();
      
      const response = await axios.post(
        "https://api.insightssystem.com/api:bVXsw_FD/web/label_management",
        {
          label,
          keywords: [],
        },
        config
      );

      dispatch(addLabel(response.data));
      setIsLabelCreationOpen(false);
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || "Failed to create label. Please try again.";
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DialogLayout open={open} onOpenChange={setIsLabelCreationOpen}>
      <div className="flex h-full w-full flex-col items-start gap-4 bg-default-background px-6 py-6">
        <div className="flex w-full flex-col items-center gap-4">
          <IconWithBackground
            className="h-10 w-10 flex-none"
            size="large"
            icon="FeatherTag"
          />
          <div className="w-full text-center">
            <span className="text-heading-2 font-heading-2 text-default-font">
              Label
            </span>
            <span className="block text-caption font-caption text-default-font">
              Create a label name for categorizing conversations
            </span>
          </div>
        </div>

        <div className="conveythis-no-translate flex w-full flex-wrap items-end gap-2">
          <TextField
            className="h-auto grow shrink-0 basis-0"
            label=""
            helpText=""
          >
            <TextField.Input
              className="conveythis-no-translate"
              placeholder="Enter Label"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
              disabled={loading}
            />
          </TextField>
        </div>

        {error && <span className="text-red-500 text-sm">{error}</span>}

        <div className="flex w-full flex-col items-center justify-center gap-4">
          <Button onClick={handleSave} disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </Button>
        </div>
      </div>
    </DialogLayout>
  );
}

export default LabelCreation;
